module.exports = __webpack_public_path__ + "static/media/11.073dbc2c.jpg";